import { useCallback, useMemo } from 'react'
import { Dataset, DATASET } from '../constants/dataset'
import { UPLOAD_JOB_ID_KEY } from '../constants/storage'
import { ApplyPanel } from './ApplyPanel'
import { UpdateProgressState } from './UpdateState'

type ApplyPanelProps = {
  uploadedInfo: {
    name?: string
    dataset: Dataset
    uploadToken?: string
  } | null
  updateInfo: {
    name?: string
    dataset: Dataset
    jobId: string
  } | null
  jobId?: string
  setUpdateInfo: (props: {
    name?: string
    dataset: Dataset
    jobId: string
  }) => void
  onComplete: () => void
}

export function ApplyPanels({
  uploadedInfo,
  updateInfo,
  jobId,
  setUpdateInfo,
  onComplete,
}: ApplyPanelProps) {
  const { dataset, uploadToken } = uploadedInfo || {}

  const handleSetJobId = useCallback(
    (executedDataset: Dataset, value: string) => {
      const executedIsAll = executedDataset === DATASET.ALL
      const data = {
        name: executedIsAll ? undefined : uploadedInfo?.name,
        dataset: executedDataset,
        jobId: value,
      }
      sessionStorage.setItem(UPLOAD_JOB_ID_KEY, JSON.stringify(data))
      setUpdateInfo(data)
    },
    [uploadedInfo, setUpdateInfo],
  )

  const isDisabled = useMemo(
    () => !!jobId || !dataset || !uploadToken,
    [dataset, jobId, uploadToken],
  )

  return (
    <div className="flex flex-col gap-4 items-center border border-gray-300 rounded-lg">
      <div className="flex justify-between gap-6 px-4 pt-4 w-full">
        <ApplyPanel
          buttonLabel="マスタ反映"
          disabled={isDisabled}
          dataset={dataset}
          uploadToken={uploadToken}
          setJobId={handleSetJobId}
        >
          <p>アップロードしたファイルのみを</p>
          <p>データベースに反映する。</p>
        </ApplyPanel>
        <ApplyPanel
          buttonLabel="全件マスタ反映"
          disabled={!!jobId}
          dataset={DATASET.ALL}
          setJobId={handleSetJobId}
        >
          <p>最新日付のデータを全件</p>
          <p>データベースに反映する。</p>
        </ApplyPanel>
      </div>
      <UpdateProgressState
        dataset={updateInfo?.dataset || DATASET.ALL}
        jobId={jobId}
        name={updateInfo?.name}
        onComplete={onComplete}
      />
    </div>
  )
}
